var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.611 21.887-5.944-2.112L3.5 21.803a1 1 0 0 1-.542.07 1.3 1.3 0 0 1-.486-.183 1 1 0 0 1-.347-.38A1.2 1.2 0 0 1 2 20.76V4.959q0-.366.208-.648.21-.282.57-.423l5.166-1.774q.167-.057.348-.085a2.4 2.4 0 0 1 1.097.085l5.944 2.112L20.5 2.197a1 1 0 0 1 .542-.07q.264.042.486.183t.347.38.125.55v15.802q0 .366-.208.648a1.26 1.26 0 0 1-.57.423l-5.166 1.774a2 2 0 0 1-.348.085 2.4 2.4 0 0 1-1.097-.085m-.389-2.507V6.197L9.778 4.62v13.183zm2.222 0 3.334-1.126V4.9l-3.334 1.296zM4.222 19.1l3.334-1.296V4.62L4.222 5.746z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.b55e71629ae404c50d9a5e9b0d63f406.svg";
export { ForwardRef as ReactComponent };